import LabServiceModel from "@/models/LabServiceModel";
import ProjectCollection from "@/collections/lab/ProjectCollection";

export default class LaboratoryModel extends LabServiceModel {

  modelName() {
    return 'laboratory';
  }

  publicRoutes() {
    let routes = super.publicRoutes() || {};
    routes.fetch = process.env.VUE_APP_LAB_REPOSITORY_URL + '/api/v1/public/' + this.modelName() + '/{id}';
    return routes;
  }

  defaults() {
    return {
      id: null,
      name: null,
      legal_name: null,
      code: null,
      phone: null,
      fax: null,
      email: null,
      address: null,
      address2: null,
      country: null,
      city: null,
      region: null,
      postal: null,
      gst_number: null,
      description: null,
      created_at: null,
      updated_at: null,
      deleted_at: null,
      projects: []
    }
  }

  // Attribute mutations.
  mutations() {
    return {
      id: (val) => (this.nullStringMutator(val)),
      name: (val) => (this.nullStringMutator(val)),
      legal_name: (val) => (this.nullStringMutator(val)),
      code: (val) => (this.nullStringMutator(val)),
      phone: (val) => (this.nullStringMutator(val)),
      fax: (val) => (this.nullStringMutator(val)),
      email: (val) => (this.nullStringMutator(val)),
      address: (val) => (this.nullStringMutator(val)),
      address2: (val) => (this.nullStringMutator(val)),
      country: (val) => (this.nullStringMutator(val)),
      city: (val) => (this.nullStringMutator(val)),
      region: (val) => (this.nullStringMutator(val)),
      postal: (val) => (this.nullStringMutator(val)),
      gst_number: (val) => (this.nullStringMutator(val)),
      description: (val) => (this.nullStringMutator(val)),
      created_at: String,
      updated_at: String,
      deleted_at: String,
    }
  }

  // Attribute validation
  validation() {
    return {}
  }

  getProjects() {
    return this.getRelatedCollection(new ProjectCollection(), 'projects');
  }

}
